var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-backtop',{attrs:{"target":_vm.scroll,"bottom":30}},[_c('div',{staticClass:"back-icon"},[_c('i',{staticClass:"el-icon-arrow-up"})])])}
var staticRenderFns = []

export { render, staticRenderFns }